import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AddSchoolIncidentTypeRequest } from "../shared/AddSchoolIncidentTypeRequest";
import { DataService_SchoolIncidentTypeSetup } from "../shared/data.service";
import { SchoolIncidentTypeInUseRequest } from "../shared/SchoolIncidentTypeInUseRequest";

@Component({
	selector: "app-school-add-sitype",
	templateUrl: "./school-add-sitype.component.html",
	styleUrls: ["./school-add-sitype.component.css"],
})
export class SchoolAddSITypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolIncidentTypeSetupService: DataService_SchoolIncidentTypeSetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.user = this.dialogConfig.data.user;
		//INSERT LOAD COMBO BOX DATA
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////
	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	user: any;

	//INSERT FORM DATA
	SchoolIncidentTypeCD: any = "";
	SchoolIncidentTypeDesc: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onAddType() {
		this.errorMessage = "";

		//Error handling
		if (this.SchoolIncidentTypeCD == "") {
			this.errorMessage = "Enter a Code";
			return;
		}

		if (this.SchoolIncidentTypeDesc == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		this.CheckCode();
	}

	CheckCode() {
		let parms: SchoolIncidentTypeInUseRequest = {
			str: this.SchoolIncidentTypeCD,
			SchoolID: this.SchoolID,
		};

		var result = this.SchoolIncidentTypeSetupService.SchoolIncidentTypeCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Code already used";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: SchoolIncidentTypeInUseRequest = {
			str: this.SchoolIncidentTypeDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.SchoolIncidentTypeSetupService.SchoolIncidentTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Description already used";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		// @SchoolIncidentTypeCD VARCHAR(20),
		// @SchoolIncidentTypeDesc VARCHAR(120),
		// @DefinedByID  INT = 4,
		// @SchoolID  INT = NULL

		var DefinedBy = this.user.UserLevelID == 3 ? 3 : 4;

		let parms: AddSchoolIncidentTypeRequest = {
			SchoolIncidentTypeCD: this.SchoolIncidentTypeCD,
			SchoolIncidentTypeDesc: this.SchoolIncidentTypeDesc,
			DefinedByID: DefinedBy,
			SchoolID: this.SchoolID,
		};

		var result = this.SchoolIncidentTypeSetupService.AddType(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Incident Type was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the School Incident Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
